import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DataPointDataType, DynamicComponentBase, IDynamicComponentConfig, ValidationRuleType } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-number-integer',
  templateUrl: './d-con-number-integer.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DConNumberIntegerComponent),
      multi: true
    }
  ]
})
export class DConNumberIntegerComponent extends DynamicComponentBase {
  static KEY = 'd-con-number-integer';
  ruleType = ValidationRuleType;

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.step !== 'number') {
      config.step = 1;
    }
    if (!config.effective) {
      config.effective = [];
    }
  }
}
